import { createFileRoute } from "@tanstack/react-router";
import NegotiationsPage from "@/components/negotiations/negotiations-page";

function NegotiationsIndexRoute() {
  return <NegotiationsPage />;
}

export const Route = createFileRoute("/_app/negotiations/")({
  component: NegotiationsIndexRoute,
});
